import tips from './tips'
import copay from './copay'
import delivery from './delivery'

export default {
  'approve-type': {
    'face-2-face-id-required': {
      label: 'Identificação e assinatura presenciais obrigatórias',
      description_1: 'A receita será entregue apenas ao paciente indicado. O destinatário tem de apresentar documento de identificação e assinar, e o nome no documento tem de corresponder ao do destinatário.',
      description_2: 'O estafeta tirará uma fotografia do documento do paciente e da porta no momento da entrega.',
    },
    'face-2-face-not-required': {
      label: 'Assinatura presencial não obrigatória',
      description: 'É necessária a assinatura de qualquer adulto (18+) que viva com o paciente. O estafeta tirará uma fotografia da porta do paciente.',
    },
    'face-2-face-required': {
      label: 'Assinatura presencial obrigatória',
      description: 'É necessária a assinatura de qualquer pessoa que viva com o paciente. O estafeta tirará uma fotografia da porta do paciente.',
    },
    'non-contract-delivery': {
      label: 'Entrega sem contacto',
      description: 'O estafeta deixará a encomenda junto à porta e tirará uma fotografia, sem tentar a entrega presencial.',
    },
    'online-signature': {
      label: 'Assinatura online',
      description_1: 'O estafeta deixará a receita junto à porta e tirará uma fotografia, apenas',
      description_2: 'se o destinatário assinar online antes da entrega. Sem assinatura online, o método de entrega',
      description_3: 'passará a ser \'Assinatura presencial obrigatória\'.',
    },
    'signature-optional': {
      label: 'Assinatura opcional',
      description: 'O estafeta tentará a entrega presencial. Se não estiver ninguém em casa, deixará a encomenda junto à porta e tirará uma fotografia.',
    },
  },
  wait: 'Aguarde, por favor...',
  'promised-eta': 'Hora prevista de entrega:',
  reschedule: 'Reagendar/Alterar morada',
  tips,
  copay,
  delivery,
  dates: {
    today: 'Hoje',
    tomorrow: 'Amanhã',
    'today-at': 'Hoje às {time}',
    'date-at': '{date} às {time}',
    'before-time': 'antes das {time}',
    'time-until': '{from} - {time}',
    'time-from': '{time} - {to}',
    apt: 'apt.',
    'delivery-unavailable': 'Data de entrega indisponível',
  },
  payment: {
    error: 'Erro',
    success: 'Sucesso',
    'transaction-error': 'Erro na transação: {message}',
    okay: 'Ok',
    'copay-success': 'Copagamento efetuado com sucesso',
    'success-bang': 'Sucesso!',
  },
  role: {
    driver: 'Estafeta',
    dispatcher: 'Despachante',
  },
  'address-check': {
    title: 'Morada alterada',
    entered: 'Morada introduzida:',
    validated: 'Morada validada:',
    accept: 'ACEITAR ALTERAÇÕES',
    keep: 'A minha morada está correta',
    cancel: 'Cancelar',
  },
  push: {
    title: 'Ativar notificações push',
    message: 'Receba atualizações imediatas do estado da entrega através de notificações do navegador.',
  },
}
